module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-ace.a3fd2b62.svg";